/**
 * OrbDocTutorialsIntermediateGuardsAROrbDocTutorialsIntermediateGuardsARPage
 *
 * Page component for OrbDocTutorialsIntermediateGuardsAROrbDocTutorialsIntermediateGuardsARPage
 * Path: /ar/docs/tutorials/intermediate/guards
 *
 * @generated from schema
 */

import React from 'react';
import { useLocation } from 'react-router-dom';
import type { EventPayload } from '@almadar/core';
import { OrbDocTutorialsIntermediateGuardsARDocScreenView as __OrbDocTutorialsIntermediateGuardsARDocScreenView } from '@/components/traits/OrbDocTutorialsIntermediateGuardsARDocScreenView';
import { OrbDocTutorialsIntermediateGuardsARDocAnalyticsView as __OrbDocTutorialsIntermediateGuardsARDocAnalyticsView } from '@/components/traits/OrbDocTutorialsIntermediateGuardsARDocAnalyticsView';
import { VStack, UISlotComponent } from '@almadar/ui/components';
import { usePageHead } from '@almadar/ui/hooks';

interface OrbDocTutorialsIntermediateGuardsAROrbDocTutorialsIntermediateGuardsARPageProps {
  // Add any page-level props here
}

export function OrbDocTutorialsIntermediateGuardsAROrbDocTutorialsIntermediateGuardsARPage(_props: OrbDocTutorialsIntermediateGuardsAROrbDocTutorialsIntermediateGuardsARPageProps) {
  const __location = useLocation();
  const __navState = (__location.state ?? {}) as EventPayload;

  usePageHead({ "title":"الشروط","description":"اجعل الانتقال مشروطًا بالكيان أو الحمولة أو الزائر، واحتفظ بكل قاعدة في مكان واحد.","access":"public","indexing":"index","origin":"https://orb.almadar.io","siteName":"Orb","alternates":[{"locale":"en","path":"/docs/tutorials/intermediate/guards"},{"locale":"ar","path":"/ar/docs/tutorials/intermediate/guards"},{"locale":"sl","path":"/sl/docs/tutorials/intermediate/guards"}],"defaultLocale":"en", path: __location.pathname });

  return (
    <>
      <UISlotComponent slot="main">
        <VStack gap="lg" className="w-full">
          <__OrbDocTutorialsIntermediateGuardsARDocScreenView config={{ initPayload: __navState }} />
          <__OrbDocTutorialsIntermediateGuardsARDocAnalyticsView config={{ initPayload: __navState }} />
        </VStack>
      </UISlotComponent>
    </>
  );
}

export default OrbDocTutorialsIntermediateGuardsAROrbDocTutorialsIntermediateGuardsARPage;
